//
//
//
//
//
//
//


export default {"name":"icon-f1589172aa70226220106f970f4e30a0"}

